
define('ldsh!modules/tax/item/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>Tax</h1>\n<dl>\n  \n\t <dd>\n   <span name="name"></span>\n  </dd>\n  \n\t <dd>\n   <span name="rate"></span>\n  </dd>\n  \n\t <dd>\n   <span name="number"></span>\n  </dd>\n  \n\t <dd>\n   <span name="compound"></span>\n  </dd>\n\n</dl>';

}
return __p
};});

